import 'antd/dist/antd.less';

import EasyEstimatorPage from 'pages/easy-estimator/easy-estimator-page';
import React, { Suspense } from 'react';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { reduxStore } from 'redux/store';
import { AnalyticsProvider } from 'use-analytics';

import GTM_ID_BY_URL from '@common/constants/gtmIdByUrl';
import HOTJAR_ID_BY_URL from '@common/constants/hotjarIdByUrl';
import FullPageLoader from '@components/FullPageLoader';
import useGoogleTagManager from '@core/hooks/useGoogleTagManager';
import useHotjar from '@core/hooks/useHotjar';
import { analytics } from '@core/initAnalytics';
import { ContextProvider } from '@ee-context';

import i18n from './core/i18n/i18n';

import './App.scss';

const App: React.FC = () => {
    useGoogleTagManager({ gtmIdByUrl: GTM_ID_BY_URL });
    useHotjar({ hotJarIdByUrl: HOTJAR_ID_BY_URL });

    return (
        <div className="App">
            <Suspense fallback={<FullPageLoader />}>
                <I18nextProvider i18n={i18n}>
                    <Provider store={reduxStore}>
                        <AnalyticsProvider instance={analytics}>
                            <ContextProvider>
                                {/* TODO: Hardcoded Maintenance Page */}
                                {/* <MaintenancePage /> */}
                                <EasyEstimatorPage />
                            </ContextProvider>
                        </AnalyticsProvider>
                    </Provider>
                </I18nextProvider>
            </Suspense>
        </div>
    );
};

export default App;
